export const SET_LOGS = 'SET_LOGS'
export const CLEAR_LOGS = 'CLEAR_LOGS'


// WEBPACK FOOTER //
// ./src/store/modules/logger/mutation-types.js